import '../Fusion/Document/Fragment/OfficeSelectorToggle'

// Polyfill missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

var officeVisited = document.querySelector('#bf-office');
if (officeVisited) {
    var officeIdentifier = officeVisited.getAttribute('data-office-identifier');
    if (officeIdentifier) {
        localStorage.setItem('bfOffice', officeIdentifier);
    }
    var officeTitle = officeVisited.getAttribute('data-office-title');
    if (officeTitle) {
        localStorage.setItem('bfOfficeTitle', officeTitle);
    }
}

var officeAlreadyVisited = localStorage.getItem('bfOffice');
if (officeAlreadyVisited) {
    var dynamicProperties = document.querySelectorAll('.bf-office_dynamic-properties');
    dynamicProperties.forEach(function(dynamicProperty) {
        var properties = dynamicProperty.querySelectorAll('.bf-office_property');
        var dynamicPropertyMatch = false;
        var defaultProperty = null;
        properties.forEach(function (property) {
            property.classList.add('d-none');
            if (property.getAttribute('data-office-identifier') === officeAlreadyVisited) {
                property.classList.add('d-inline-block');
                dynamicPropertyMatch = true;
            }
            if (property.getAttribute('data-office-identifier') === 'default') {
                defaultProperty = property;
            }
        });
        if (!dynamicPropertyMatch && defaultProperty) {
            defaultProperty.classList.toggle('d-none');
        }
    });

    // Populate form field(s)
    var officeLastVisited = localStorage.getItem('bfOfficeTitle');
    if (officeLastVisited) {
        var officeLastVisitedFormField = document.querySelector('#form-officeLastVisited');
        if (officeLastVisitedFormField) {
            officeLastVisitedFormField.value = officeLastVisited
        }
    }
}
